import { PropsWithChildren } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { ProfileProvider } from "./ProfileContext";

const ACCOUNT_PATHS = ["/main", "/profile", "/pay", "/install"];

// Keep the cache mounted across routes, while public pages leave profile loading idle.
export const AccountProfileProvider = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const enabled = ACCOUNT_PATHS.some((path) => matchPath(path, pathname) !== null);

  return <ProfileProvider enabled={enabled} refreshKey={pathname}>{children}</ProfileProvider>;
};
